import {
  AmbienteDoUsuarioResposta,
  AuthUserPoolResposta,
  AutenticacaoResposta,
  Credenciais,
  CriarNovaSenha,
} from "./autenticacao.modelo"
import { RepositorioBase } from "@/http"

class AutenticacaoRepositorio extends RepositorioBase {
  public constructor() {
    super({
      baseUrl: process.env.VUE_APP_GESTAO_BASE_URL,
    })
  }

  public autenticar = (dados?: Credenciais): Promise<AutenticacaoResposta> =>
    this.instance.post("/api/auth", dados, {
      headers: { "x-pontotel-dispositivo": "web" },
    })

  public descobrirAmbienteDoUsuario = (
    email: string
  ): Promise<AmbienteDoUsuarioResposta> =>
    this.instance.get(
      `/api/ambientes-do-usuario/${encodeURIComponent(email)}`
    )

  public obterAuthUserPool = (
    email: string
  ): Promise<AuthUserPoolResposta> =>
    this.instance.post("/api/auth-user-pool/frontend", { email })

  public recuperarSenhaCognito = (email: string): Promise<void> =>
    this.instance.post("/api/auth-cognito-forgot-password", { email })

  public recuperarSenha = (
    email: string,
    tokenRecaptcha = "token_recaptcha"
  ): Promise<void> =>
    this.instance.get(
      `/api/esqueci-minha-senha/${encodeURIComponent(email)}/${encodeURIComponent(
        tokenRecaptcha
      )}`
    )

  public criarNovaSenha = (dados?: CriarNovaSenha): Promise<void> =>
    this.instance.post("/api/auth-confirm-migration-user-cognito", dados)

  public logout = (): Promise<void> =>
    this.instance.get("/api/auth-logout")

}

export default AutenticacaoRepositorio
